// Copy for NotFoundPage.tsx and the Worker's edge-rendered 404 document (web/worker.ts). Same
// fallback-to-English precedent as the other page-specific dictionaries (see environmentCheckStrings.ts).
export interface NotFoundStrings {
  documentTitle: string;
  metaDescription: string;
  heading: string;
  title: string;
  body: string;
  backHome: string;
  ipCheck: string;
  blog: string;
}

const en: NotFoundStrings = {
  documentTitle: "Page Not Found | NetRiskScan",
  metaDescription: "The page you requested could not be found.",
  heading: "404",
  title: "Page not found",
  body: "The page you're looking for doesn't exist or may have moved.",
  backHome: "Back to NetRiskScan",
  ipCheck: "IP Risk Check",
  blog: "Knowledge Hub",
};

const zhCn: NotFoundStrings = {
  documentTitle: "页面未找到 | NetRiskScan",
  metaDescription: "抱歉,未找到您请求的页面。",
  heading: "404",
  title: "页面未找到",
  body: "您访问的页面不存在,或已被移动。",
  backHome: "返回 NetRiskScan",
  ipCheck: "IP 风险检测",
  blog: "知识中心",
};

const zhTw: NotFoundStrings = {
  documentTitle: "頁面未找到 | NetRiskScan",
  metaDescription: "抱歉,未找到您請求的頁面。",
  heading: "404",
  title: "頁面未找到",
  body: "您造訪的頁面不存在,或已被移動。",
  backHome: "返回 NetRiskScan",
  ipCheck: "IP 風險檢測",
  blog: "知識中心",
};

const ja: NotFoundStrings = {
  documentTitle: "ページが見つかりません | NetRiskScan",
  metaDescription: "お探しのページが見つかりませんでした。",
  heading: "404",
  title: "ページが見つかりません",
  body: "お探しのページは存在しないか、移動した可能性があります。",
  backHome: "NetRiskScan に戻る",
  ipCheck: "IP リスクチェック",
  blog: "ナレッジハブ",
};

const ko: NotFoundStrings = {
  documentTitle: "페이지를 찾을 수 없습니다 | NetRiskScan",
  metaDescription: "요청하신 페이지를 찾을 수 없습니다.",
  heading: "404",
  title: "페이지를 찾을 수 없습니다",
  body: "찾으시는 페이지가 존재하지 않거나 이동되었을 수 있습니다.",
  backHome: "NetRiskScan으로 돌아가기",
  ipCheck: "IP 위험 검사",
  blog: "지식 허브",
};

const es: NotFoundStrings = {
  documentTitle: "Página no encontrada | NetRiskScan",
  metaDescription: "No se pudo encontrar la página solicitada.",
  heading: "404",
  title: "Página no encontrada",
  body: "La página que buscas no existe o puede haberse movido.",
  backHome: "Volver a NetRiskScan",
  ipCheck: "Comprobación de riesgo IP",
  blog: "Centro de conocimiento",
};

const de: NotFoundStrings = {
  documentTitle: "Seite nicht gefunden | NetRiskScan",
  metaDescription: "Die angeforderte Seite konnte nicht gefunden werden.",
  heading: "404",
  title: "Seite nicht gefunden",
  body: "Die gesuchte Seite existiert nicht oder wurde verschoben.",
  backHome: "Zurück zu NetRiskScan",
  ipCheck: "IP-Risikoprüfung",
  blog: "Wissensdatenbank",
};

const fr: NotFoundStrings = {
  documentTitle: "Page introuvable | NetRiskScan",
  metaDescription: "La page demandée est introuvable.",
  heading: "404",
  title: "Page introuvable",
  body: "La page que vous recherchez n'existe pas ou a peut-être été déplacée.",
  backHome: "Retour à NetRiskScan",
  ipCheck: "Vérification du risque IP",
  blog: "Centre de connaissances",
};

const ptBr: NotFoundStrings = {
  documentTitle: "Página não encontrada | NetRiskScan",
  metaDescription: "A página solicitada não pôde ser encontrada.",
  heading: "404",
  title: "Página não encontrada",
  body: "A página que você procura não existe ou pode ter sido movida.",
  backHome: "Voltar ao NetRiskScan",
  ipCheck: "Verificação de risco de IP",
  blog: "Central de conhecimento",
};

const ru: NotFoundStrings = {
  documentTitle: "Страница не найдена | NetRiskScan",
  metaDescription: "Запрошенная страница не найдена.",
  heading: "404",
  title: "Страница не найдена",
  body: "Запрашиваемая страница не существует или была перемещена.",
  backHome: "Вернуться на NetRiskScan",
  ipCheck: "Проверка риска IP",
  blog: "База знаний",
};

const dictionaries: Record<string, NotFoundStrings> = {
  en,
  "zh-cn": zhCn,
  "zh-tw": zhTw,
  ja,
  ko,
  es,
  de,
  fr,
  "pt-br": ptBr,
  ru,
};

export function getNotFoundStrings(languageCode: string): NotFoundStrings {
  return dictionaries[languageCode.toLowerCase()] ?? en;
}
